import { UIInteractionEvent } from "./UIInteractionEvent";

export abstract class UIInteraction<E extends UIInteractionEvent>
{
  abstract update( e:E ):void;
  onFocus(){}
  onBlur(){}
  
}